import { LINKS } from "../content/site";

const CONTENT_NS = "http://purl.org/rss/1.0/modules/content/";
const CREATOR_NS = "http://purl.org/dc/elements/1.1/";

const plainText = (html) => new DOMParser()
  .parseFromString(html || "", "text/html").body.textContent.trim();

const imageUrl = (value) => {
  try {
    const url = new URL(value);
    return url.protocol === "https:" ? url.href : null;
  } catch {
    return null;
  }
};

export const parseLogbookFeed = (xml) => {
  const document = new DOMParser().parseFromString(xml, "application/xml");
  if (document.querySelector("parsererror") || document.documentElement.localName !== "rss" || !document.querySelector("channel")) {
    throw new Error("The Logbook feed could not be read.");
  }

  const posts = new Map();
  const items = Array.from(document.querySelectorAll("channel > item"));
  for (const item of items) {
    const text = (tag) => item.getElementsByTagName(tag)[0]?.textContent.trim() || "";
    let link;
    try {
      link = new URL(text("link"));
    } catch {
      continue;
    }
    const slug = link.pathname.match(/^\/p\/([^/]+)\/?$/)?.[1];
    if (link.origin !== new URL(LINKS.beehiiv).origin || !slug || !text("title")) continue;

    const content = item.getElementsByTagNameNS(CONTENT_NS, "encoded")[0]?.textContent || "";
    const published = new Date(text("pubDate"));
    const words = plainText(content).split(/\s+/).filter(Boolean).length;
    const categories = Array.from(item.getElementsByTagName("category"), (category) => category.textContent.trim()).filter(Boolean);
    if (!posts.has(slug)) posts.set(slug, {
      slug,
      title: plainText(text("title")),
      subtitle: plainText(text("description")),
      link: link.href,
      image: imageUrl(item.querySelector("enclosure")?.getAttribute("url")),
      published: Number.isNaN(published.getTime()) ? null : published.toISOString(),
      author: item.getElementsByTagNameNS(CREATOR_NS, "creator")[0]?.textContent.trim() || "x1025",
      categories: [...new Set(categories)],
      reading_minutes: Math.max(1, Math.round(words / 230)),
      content_html: content,
    });
  }

  if (items.length && !posts.size) throw new Error("The Logbook feed contained no readable entries.");
  const sorted = [...posts.values()].sort((a, b) => (Date.parse(b.published) || 0) - (Date.parse(a.published) || 0));
  return { posts: sorted, categories: [...new Set(sorted.flatMap((post) => post.categories))].sort() };
};

export const fetchLogbookFeed = async (url) => {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 12000);
  try {
    const response = await fetch(url, {
      signal: controller.signal,
      credentials: "omit",
      cache: "no-store",
    });
    if (!response.ok) throw new Error("The Logbook feed is unavailable.");
    return parseLogbookFeed(await response.text());
  } finally {
    clearTimeout(timeout);
  }
};
